export const COMPS_STICKY_ROWS_CONTAINER_ID = 'comps-sticky-rows-container'
export const COMPS_STICKY_ROWS_VISIBLE_CLASS = 'comps-sticky-rows-visible'
